import notify from './feedback/notifications';
import { Translate } from './LanguageService';

export function handleError(error: any, callback?: (e: any) => void): void {
    // Fire-and-forget wrapper kept for the existing call sites: it still throws synchronously
    // when there is no response, and returns void so `.catch((e) => handleError(e))` inside a
    // typed promise chain keeps compiling. Await handleErrorAsync instead when the caller needs
    // to know that no reason could be read from the body.
    handleErrorAsync(error, callback);
}

// Rejects when the response body cannot be read as JSON — an empty 500, or an HTML error page
// from a proxy (504). Throws synchronously when there is no response at all (network failure).
export function handleErrorAsync(error: any, callback?: (e: any) => void): Promise<void> {
    if (!error.response) {
        throw error;
    }

    return error.response.json().then((errorResponse: any) => {
        let errors: any = {};
        if (errorResponse.exceptionMessage) {
            notify.failure(errorResponse.exceptionMessage);
        } else if (errorResponse.error) {
            if (errorResponse.error.shouldTranslate) {
                if (errorResponse.error.shouldDisplayAsWarning) {
                    notify.warning(Translate(errorResponse.error.message));
                } else {
                    notify.failure(Translate(errorResponse.error.message));
                }
            } else {
                notify.failure(errorResponse.error.message);
            }
        } else if (errorResponse.errors) {
            let topmostHtmlElementWithErrorMessage = null;
            errorResponse.errors.forEach((e: IKeyValueState) => {
                if (e.type.display === 'notification') {
                    notify.failure(Translate(e.value, e.type.values));
                } else {
                    let lowerCaseFirstLetterInKey = e.key.charAt(0).toLowerCase() + e.key.slice(1);
                    errors[lowerCaseFirstLetterInKey] = Translate(e.value as string, e.type.values);

                    let htmlElements = document.querySelectorAll(
                        `[data-validation-key='${lowerCaseFirstLetterInKey}']`
                    );
                    if (htmlElements.length > 0) {
                        let position = htmlElements[0].getBoundingClientRect().top;
                        if (topmostHtmlElementWithErrorMessage) {
                            if (
                                topmostHtmlElementWithErrorMessage.getBoundingClientRect().top >
                                position
                            ) {
                                topmostHtmlElementWithErrorMessage = htmlElements[0];
                            }
                        } else {
                            topmostHtmlElementWithErrorMessage = htmlElements[0];
                        }
                    } else {
                        notify.failure(Translate(e.value, e.type.values));
                    }
                }
            });
            if (topmostHtmlElementWithErrorMessage) {
                topmostHtmlElementWithErrorMessage.firstChild.focus();
            }
        }
        if (callback) {
            callback(errors);
        }
    });
}

interface IKeyValueState {
    key: string;
    value: string;
    type: IErrorData;
}

interface IErrorData {
    display: string;
    values: any;
}
